import { render } from "./MultiDateComponent.vue?vue&type=template&id=b809b112&ts=true"
import script from "./MultiDateComponent.vue?vue&type=script&lang=ts"
export * from "./MultiDateComponent.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\a\\1\\s\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__